import { render, staticRenderFns } from "./BusinessCategoryChooser.vue?vue&type=template&id=19f9feb3&"
import script from "./BusinessCategoryChooser.vue?vue&type=script&lang=js&"
export * from "./BusinessCategoryChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports